import * as endpoints from './endpoints';
import * as api from 'config/axios';

export const verifyWalmartLogin = (params) => {
  return api.sendGet(endpoints.VERIFY_WALMART_LOGIN);
};

export const downloadWalmartForm = (payload) => {
  return api.requestToDownload({
    method: 'POST',
    apiEndpoint: endpoints.DOWNLOAD_WALMART_FORM,
    payload,
  });
};

export const getWalmartProductSchema = (params) => {
  return api.sendPost(endpoints.GET_WALMART_PRODUCT_SCHEMA, params);
};

export const getInitialWalmartProductData = (params) => {
  return api.sendPost(endpoints.GET_INITIAL_WALMART_PRODUCT_DATA, params);
};

export const validateWalmartProductData = (params) => {
  return api.sendPost(endpoints.VALIDATE_WALMART_PRODUCT_DATA, params);
};

export const getWalmartProductAssets = (params) => {
  return api.sendGet(endpoints.GET_WALMART_PRODUCT_ASSETS, { params });
};

export const checkAllowPostToGdsnWalmartRecipient = (params) => {
  return api.sendPost(
    endpoints.CHECK_ALLOW_POST_GDSN_WALMART_RECIPIENTS,
    params
  );
};
